import React, { useEffect, useState } from "react";
import Usage from '../../assets/images/usage.gif'
import { useTranslation } from "react-i18next";

const InstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const { t } = useTranslation()

  useEffect(() => {
    const isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);
    const hasSeenPrompt = localStorage.getItem("hasSeenInstallPrompt");

    const isInStandaloneMode =
      window.matchMedia('(display-mode: standalone)').matches || // Android Chrome
      window.navigator.standalone === true ||                    // iOS Safari
      window.location.href.includes('utm_source=homescreen');    // URL orqali

    // ❌ Modal faqat mobilda, hali o‘rnatilmagan va ilgari ko‘rsatilmagan bo‘lsa chiqadi
    if (isMobile && hasSeenPrompt == 'false' && !isInStandaloneMode) {
      setShowPrompt(true);
      localStorage.setItem("hasSeenInstallPrompt", "true");
    }
  }, []);

  const handleClose = () => {
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <img src={Usage} alt="Logo" style={{ width: '100%', height: 'auto', marginBottom: 20 }} />
        <p style={styles.title}>{t('USAGE_TITLE')}</p>
        <ol style={styles.list}>
          <li>{t('USAGE_BODY1')}</li>
          <li>{t('USAGE_BODY2')}</li>
          <li>{t('USAGE_BODY3')}</li>
        </ol>
        <p style={styles.note}>{t('USAGE_BODY_INFO')}</p>
        <button style={styles.button} onClick={handleClose}>{t('THANK_YOU')}</button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    zIndex: 9999,
  },
  modal: {
    backgroundColor: "#fff",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    width: "100%",
    padding: 20,
    height: "80vh",
    overflowY: "auto",
  },
  title: {
    fontWeight: "bold",
    fontSize: 18,
    marginBottom: 10,
  },
  list: {
    paddingLeft: 20,
    fontSize: 16,
  },
  note: {
    marginTop: 10,
    fontSize: 14,
    color: "#666",
  },
  button: {
    marginTop: 20,
    width: "100%",
    padding: 12,
    backgroundColor: "#25B17B",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontSize: 16,
    fontWeight: "bold",
  },
};

export default InstallPrompt;
